import {s3Path} from "../../misc/utils";

export default class Layer {
    zIndex = 0;

    src = '';

    fromS3 = true;

    /**
     * @param visualizer {string} bv or kv
     * @param zIndex {number}
     * @param src {string}
     * @param fromS3 {boolean} Whether the layer comes from S3 bucket ir from local resources
     */
    constructor(visualizer, zIndex = 0, src = '', fromS3 = true) {
        this.zIndex = zIndex;
        this.src = src;
        this.fromS3 = fromS3;
        this.visualizer = visualizer;
        this.bucketName = "";
    }

    /**
     *
     * @returns {{backgroundImage}|*}
     */
    bgImg(isCropped) {
      return this.fromS3 ? s3Path(this.src, this.visualizer, isCropped, this.bucketName) : this.src;
    }

    fromS3Binding(s3Binding) {
        this.src = s3Binding ? s3Binding.path : null;
        this.bucketName = s3Binding ? s3Binding.bucketName : "";
    }

    /**
     *
     * @param ar {Array.<Layer>}
     */
    addTo(ar) {
        if (this.src)
            ar.push(this);
    }
}


